<div class="tab-container tabs-shadow">
    <ul class="nav nav-tabs mx-0 mb-0 pl-0">
        <li class="pb-2  li-m primary-text light-text" *ngFor="let tab of tabs; let i = index" (click)="selectTab(tab,i)" [ngClass]="[clickchange ? 'enable-action':'disable-action',tab.disable == 'true' ? 'permission-denied': 'enable-action']" [class.active]="tab.active">
            <a>{{tab.title}}</a>
        </li>
    </ul>
    <div class="close-icon pr-3" *ngIf="callbackFunction">
        <img src="../../../../assets/close-dialog.svg" class="icon-s enable-action" (click)="executeCallback()">
    </div>
</div>

<ng-content></ng-content>